'use client';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component, createRef, memo } from 'react';
import shave from 'shave';
import { jsx as _jsx } from "react/jsx-runtime";
class MultilineEllipsis extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "containerRef", /*#__PURE__*/createRef());
    _defineProperty(this, "applyMultilineEllipsis", () => {
      var {
        maxHeight
      } = this.props;

      // Ref is always available in componentDidMount or after,
      // cast the type to make TypeScript happy.
      shave(this.containerRef.current, maxHeight);
    });
  }
  componentDidMount() {
    this.applyMultilineEllipsis();
    // Re-apply ellipsis after fonts are loaded.
    window.addEventListener('load', this.applyMultilineEllipsis);
    window.addEventListener('resize', this.applyMultilineEllipsis);
  }
  componentDidUpdate() {
    this.applyMultilineEllipsis();
  }
  componentWillUnmount() {
    window.removeEventListener('load', this.applyMultilineEllipsis);
    window.removeEventListener('resize', this.applyMultilineEllipsis);
  }
  render() {
    var {
      children: text,
      className
    } = this.props;
    return /*#__PURE__*/_jsx("span", {
      className: className,
      ref: this.containerRef,
      title: text,
      children: text
    });
  }
}
_defineProperty(MultilineEllipsis, "defaultProps", {
  className: ''
});
var MemoMultilineEllipsis = /*#__PURE__*/memo(MultilineEllipsis);
export { MemoMultilineEllipsis as MultilineEllipsis };